module.exports = __webpack_public_path__ + "assets/ubike.png?0b87b42bb432d2f88d1199014e8e3fb7";